import { AttachmentBlockComponent } from './attachment-block';
import { AttachmentEdgelessBlockComponent } from './attachment-edgeless-block';

export function effects() {
  customElements.define(
    'hive-edgeless-attachment',
    AttachmentEdgelessBlockComponent
  );
  customElements.define('hive-attachment', AttachmentBlockComponent);
}
